import React, {useRef} from "react";
import {Dialog, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {background1} from "../../audio";

const PlayMusicDialog = (props) => {
    const { onCancel, onListened, thresholdPercent = 90 } = props;
    const ref = useRef(null);
    const triggered = useRef(false);

    const checkPercentListened = (audio) => {
        if (audio) {
            const total = audio.duration;
            const current = audio.currentTime;
            const percent = total > 0
                ? Math.min((current / total) * 100, 100)
                : 0;

            console.log("percent listened: " + percent);

            if (percent >= thresholdPercent) {
                if (onListened && !triggered.current) {
                    triggered.current = true;
                    onListened(percent);
                }
            }
        }
    };

    const onClose = () => {
        checkPercentListened(ref.current);
        onCancel();
    };

    return <Dialog
        open={true}
        aria-labelledby="play-music-dialog"
    >
        <ClosableDialogTitle onClose={onClose}>
            Theme song
        </ClosableDialogTitle>
        <DialogContent className="play-music-dialog">
            <div className="audio">
                <audio
                    ref={ref}
                    controls={true}
                    onTimeUpdate={e => checkPercentListened(ref.current)}
                    onEnded={e => checkPercentListened(ref.current)}
                >
                    <source src={background1} type="audio/mpeg"/>
                </audio>
            </div>
        </DialogContent>
    </Dialog>
}

export default PlayMusicDialog;
